import React from 'react';
import { newSearchCustomers } from '../../../networking/Networking';
import { getStyle } from '../../../styles/styles';
import NewDynamicTable from '../../shared/NewDynamicTable';
import { getDefaultPagingNumberOfItems } from '../../../helpers/PackageJsonHelper'

export default class WizardSearchCustomerForm extends React.Component {
    state = {
        searchTerm: '',
        pages: 1,
        totalPages: 0,
        customerList: [],
        newSearch: false,
        filter: false
    }

    handleUpdateSearchTerm = (event) => {
        this.setState({ searchTerm: event.target.value });
    }

    loadCustomers = async () => {
        const itemsPerPage = getDefaultPagingNumberOfItems();
        const value = await newSearchCustomers(this.state.searchTerm, sessionStorage.getItem('AgentCustomerID'), 0, 0);
        if (value !== undefined) {
            const totalCount = value.totalCount;
            const totalPages = Math.ceil(totalCount / itemsPerPage);
            this.setState({
                totalPages,
                newSearch: true,
                filter: true,
                customerList: value.customers
            });
        }
    }

    changePage = (value) => {
        this.setState({ pages: value });
    }

    handleSearchClick = async (event) => {
        event.preventDefault();
        await this.loadCustomers();
    }

    handleRecordClick = (objCustomer) => {
        this.props.onCustomerSelected(objCustomer, 2);
    }

    getAllCustomers = async () => {
        const value = await newSearchCustomers('', sessionStorage.getItem('AgentCustomerID'), 0, 0);
        if (value.customers !== undefined) {
            return value.customers;
        } else {
            return [];
        }
    }

    render() {
        return (
            <div>
                <form className="uk-grid">
                    <div className="uk-width-1-2">
                        <div className="uk-margin" style={{ ...getStyle().inputStyle, marginTop: '5px' }}>
                            <input className="uk-input" id="searchTerm" type="text" value={this.state.searchTerm} onChange={this.handleUpdateSearchTerm} />
                        </div>
                    </div>
                    <div className="uk-width-1-2">
                        <div className="uk-margin" style={getStyle().inputStyle}>
                            <button className="uk-button uk-button-green" onClick={this.handleSearchClick}>Search</button>
                        </div>
                    </div>
                </form>
                <NewDynamicTable data={this.state.customerList}
                    enableClick={true}
                    clickFunction={this.handleRecordClick}
                    newSearch={this.state.newSearch}
                    useDeleteButton={false}
                    hiddenHeaders={['FeeStructureID', 'WireFeeSide', 'RelatedWireFeeID', 'DefaultBuyCurrencyID', 'DefaultSellCurrencyID']}
                    usePaginator={true}
                    changePage={this.changePage}
                    numberOfPages={this.state.totalPages}
                    pageNumber={this.state.pages}
                    numberPerPage={getDefaultPagingNumberOfItems()}
                    enableSortByHeader={true}
                    useFilter={this.state.filter}
                    filterFunction={this.getAllCustomers}
                />
            </div>
        )
    }
}